import { FIND_USER_IN_PIANO, PERSONALIZATION_API_KEY } from './constants';

const findUserInPiano = async (email: string) => {
  const url = `${FIND_USER_IN_PIANO}?email=${email}`;
  const response = await fetch(url, {
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'GET',
  });

  if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
  const message = (await response.json()) as { message: string };

  return message.message !== 'false';
};

export default findUserInPiano;
